export {};

export const PATH_ROOT: string = '/';
export const PATH_WORKLIST: string = PATH_ROOT + 'workList';
export const PATH_WORKSEARCH: string = PATH_ROOT + 'workSearch';
export const PATH_WORKPLAN: string = PATH_ROOT + 'workPlan';
export const PATH_WORKITEM: string = PATH_ROOT + 'workItem';
export const PATH_GROUPLIST: string = PATH_ROOT + 'groupList';
export const PATH_ORIGINSETTING: string = PATH_ROOT + 'originSetting';
export const PATH_PLANRESULT: string = PATH_ROOT + 'planResult';
export const PATH_DRAFT_CONDITION_SETTING: string = PATH_ROOT + 'DraftConditionSetting';

export const FORMAT_DATE_YYYYMMDD: string = 'YYYYMMDD';
export const FORMAT_DATE_YYYYMM: string = 'YYYYMM';
export const FORMAT_DATE_YYYY_MM_DD: string = 'YYYY-MM-DD';
export const FORMAT_DATE_YYYY_M_D_SLASH: string = 'YYYY/M/D';
export const FORMAT_DATE_YYYY_MM_DD_JPN: string = 'YYYY年MM月DD日';
export const FORMAT_DATE_YYYY_M_JPN: string = 'YYYY年M月';
export const FORMAT_DATE_M_D_JPN: string = 'M月D日';
export const FORMAT_DATE_YYYY_MM: string = 'YYYY-MM';
export const FORMAT_DATE_M: string = 'M';
export const FORMAT_DATE_D: string = 'D';

export const PAGE_RANGE: string = '98%';

export type PriorityValue = 5 | 4 | 3 | 2 | 1;
export const Priority: { [key: string]: PriorityValue } = {
  required: 5,
  high: 4,
  middleHigh: 3,
  middle: 2,
  low: 1,
};

export type Permission = number;

class Permissions {
  /** 権限なし */
  NONE = 0;

  /** 「自支所」登録支所 トップ 参照可能 */
  TOP_MAIN_REFERENCE = 0;

  //

  /** 支所管理 「自支所」登録支所 編集可能 */
  BRANCH_MAIN_EDIT = 0;
  /** 支所管理 「自支所」登録支所 参照可能 */
  BRANCH_MAIN_REFERENCE = 0;

  /** 支所管理 「他支所」登録支所 編集可能 */
  BRANCH_SUB_EDIT = 0;
  /** 支所管理 「他支所」登録支所 参照可能 */
  BRANCH_SUB_REFERENCE = 0;

  /** 支所管理 未登録支所 編集可能 */
  BRANCH_OTHER_EDIT = 0;
  /** 支所管理 未登録支所 参照可能 */
  BRANCH_OTHER_REFERENCE = 0;

  //

  /** ユーザ管理 「自支所」登録支所 編集可能 */
  USER_MAIN_EDIT = 0;
  /** ユーザ管理 「自支所」登録支所 参照可能 */
  USER_MAIN_REFERENCE = 0;

  /** ユーザ管理 「他支所」登録支所 編集可能 */
  USER_SUB_EDIT = 0;
  /** ユーザ管理 「他支所」登録支所 参照可能 */
  USER_SUB_REFERENCE = 0;

  /** ユーザ管理 未登録支所 編集可能 */
  USER_OTHER_EDIT = 0;
  /** ユーザ管理 未登録支所 参照可能 */
  USER_OTHER_REFERENCE = 0;

  //

  /** 初期設定 「自支所」登録支所 編集可能 */
  ORIGIN_SETTING_MAIN_EDIT = 0;
  /** 初期設定 「自支所」登録支所 編集可能 */
  ORIGIN_SETTING_MAIN_REFRENCE = 0;

  /** 初期設定 「他支所」登録支所 編集可能 */
  ORIGIN_SETTING_SUB_EDIT = 0;
  /** 初期設定 「他支所」登録支所 編集可能 */
  ORIGIN_SETTING_SUB_REFRENCE = 0;

  /** 初期設定 未登録支所 編集可能 */
  ORIGIN_SETTING_OTHER_EDIT = 0;
  /** 初期設定 未登録支所 編集可能 */
  ORIGIN_SETTING_OTHER_REFRENCE = 0;

  //

  /** 立案条件設定 「自支所」登録支所 編集可能 */
  DRAFT_CONDITION_MAIN_EDIT = 0;
  /** 立案条件設定 「自支所」登録支所 参照可能 */
  DRAFT_CONDITION_MAIN_REFERENCE = 0;

  /** 立案条件設定 「他支所」登録支所 編集可能 */
  DRAFT_CONDITION_SUB_EDIT = 0;
  /** 立案条件設定 「他支所」登録支所 参照可能 */
  DRAFT_CONDITION_SUB_REFERENCE = 0;

  /** 立案条件設定 未登録支所 編集可能 */
  DRAFT_CONDITION_OTHER_EDIT = 0;
  /** 立案条件設定 未登録支所 参照可能 */
  DRAFT_CONDITION_OTHER_REFERENCE = 0;

  //

  /** 計画実績 「自支所」登録支所 編集可能 */
  PLAN_RESULT_MAIN_EDIT = 0;
  /** 計画実績 「自支所」登録支所 参照可能 */
  PLAN_RESULT_MAIN_REFERENCE = 0;

  /** 計画実績 「他支所」登録支所 編集可能 */
  PLAN_RESULT_SUB_EDIT = 0;
  /** 計画実績 「他支所」登録支所 参照可能 */
  PLAN_RESULT_SUB_REFERENCE = 0;

  /** 計画実績 未登録支所 編集可能 */
  PLAN_RESULT_OTHER_EDIT = 0;
  /** 計画実績 未登録支所 参照可能 */
  PLAN_RESULT_OTHER_REFERENCE = 0;

  //

  /** 過去実績 「自支所」登録支所 編集可能 */
  PAST_RESULT_MAIN_EDIT = 0;
  /** 過去実績 「自支所」登録支所 参照可能 */
  PAST_RESULT_MAIN_REFERENCE = 0;

  /** 過去実績 「他支所」登録支所 編集可能 */
  PAST_RESULT_SUB_EDIT = 0;
  /** 過去実績 「他支所」登録支所 参照可能 */
  PAST_RESULT_SUB_REFERENCE = 0;

  /** 過去実績 未登録支所 編集可能 */
  PAST_RESULT_OTHER_EDIT = 0;
  /** 過去実績 未登録支所 参照可能 */
  PAST_RESULT_OTHER_REFERENCE = 0;

  //
}

export const PERMISSIONS = Object.keys(new Permissions()).reduce((permissions, key, i) => {
  // フラグ値が62ビットを超える場合はフラグ演算に使用されるすべてのnumberをBigInt()に置換する必要あり
  if (i - 1 > 62) {
    throw new Error('flag is too large');
  }

  // ビットフラグをセット
  (permissions as any)[key] = Math.max(1 << (i - 1), 0);
  return permissions;
}, {} as Permissions);

export const USER_ROLE = {
  /** スーパーユーザ 想定: 環イ担当者 */
  SUPER_USER:
    PERMISSIONS.TOP_MAIN_REFERENCE |
    //
    PERMISSIONS.BRANCH_MAIN_EDIT |
    PERMISSIONS.BRANCH_SUB_EDIT |
    PERMISSIONS.BRANCH_OTHER_EDIT |
    //
    PERMISSIONS.USER_MAIN_EDIT |
    PERMISSIONS.USER_SUB_EDIT |
    PERMISSIONS.USER_OTHER_EDIT |
    //
    PERMISSIONS.ORIGIN_SETTING_MAIN_EDIT |
    PERMISSIONS.ORIGIN_SETTING_SUB_EDIT |
    PERMISSIONS.ORIGIN_SETTING_OTHER_EDIT |
    //
    PERMISSIONS.DRAFT_CONDITION_MAIN_REFERENCE |
    PERMISSIONS.DRAFT_CONDITION_SUB_REFERENCE |
    PERMISSIONS.DRAFT_CONDITION_OTHER_REFERENCE |
    //
    PERMISSIONS.PLAN_RESULT_MAIN_REFERENCE |
    PERMISSIONS.PLAN_RESULT_SUB_REFERENCE |
    PERMISSIONS.PLAN_RESULT_OTHER_REFERENCE |
    //
    PERMISSIONS.PAST_RESULT_MAIN_REFERENCE |
    PERMISSIONS.PAST_RESULT_SUB_REFERENCE |
    PERMISSIONS.PAST_RESULT_OTHER_REFERENCE,

  /** 権限1 想定: 環イ、ROCスタッフ */
  ROLE_1:
    PERMISSIONS.TOP_MAIN_REFERENCE |
    //
    PERMISSIONS.PLAN_RESULT_MAIN_REFERENCE |
    PERMISSIONS.PLAN_RESULT_SUB_REFERENCE |
    PERMISSIONS.PLAN_RESULT_OTHER_REFERENCE |
    //
    PERMISSIONS.PAST_RESULT_MAIN_REFERENCE |
    PERMISSIONS.PAST_RESULT_SUB_REFERENCE |
    PERMISSIONS.PAST_RESULT_OTHER_REFERENCE,

  /** 権限2 想定: 所長 */
  ROLE_2:
    PERMISSIONS.TOP_MAIN_REFERENCE |
    //
    PERMISSIONS.USER_MAIN_EDIT |
    //
    PERMISSIONS.ORIGIN_SETTING_MAIN_EDIT |
    //
    PERMISSIONS.DRAFT_CONDITION_MAIN_EDIT |
    PERMISSIONS.DRAFT_CONDITION_SUB_REFERENCE |
    //
    PERMISSIONS.PLAN_RESULT_MAIN_EDIT |
    PERMISSIONS.PLAN_RESULT_SUB_REFERENCE |
    //
    PERMISSIONS.PAST_RESULT_MAIN_REFERENCE |
    PERMISSIONS.PAST_RESULT_SUB_REFERENCE,

  /** 権限3 想定: 運転所長 */
  ROLE_3:
    PERMISSIONS.TOP_MAIN_REFERENCE |
    PERMISSIONS.DRAFT_CONDITION_MAIN_EDIT |
    PERMISSIONS.DRAFT_CONDITION_SUB_REFERENCE |
    //
    PERMISSIONS.PLAN_RESULT_MAIN_EDIT |
    PERMISSIONS.PLAN_RESULT_SUB_REFERENCE |
    //
    PERMISSIONS.PAST_RESULT_MAIN_REFERENCE |
    PERMISSIONS.PAST_RESULT_SUB_REFERENCE,

  /** 権限4 想定: 運転員、環運現場在中者、OPM、設計部門 */
  ROLE_4:
    PERMISSIONS.TOP_MAIN_REFERENCE |
    PERMISSIONS.DRAFT_CONDITION_MAIN_REFERENCE |
    //
    PERMISSIONS.PLAN_RESULT_MAIN_REFERENCE |
    //
    PERMISSIONS.PAST_RESULT_MAIN_REFERENCE,

  /** 権限5 想定: OPM、設計部門 */
  ROLE_5:
    PERMISSIONS.TOP_MAIN_REFERENCE |
    //
    PERMISSIONS.DRAFT_CONDITION_SUB_REFERENCE |
    //
    PERMISSIONS.PLAN_RESULT_SUB_REFERENCE |
    //
    PERMISSIONS.PAST_RESULT_SUB_REFERENCE,
} as const;

export const MESSAGES = {
  CONFIRM_POST_FORM: '入力内容を送信します。よろしいですか。',
  CONFIRM_SAVE_FORM: '入力内容を一時保存します。よろしいですか。',
  CONFIRM_RESET_INPUT: '入力内容を編集前に戻します。よろしいですか。',

  CONFIRM_POST_HISTORY: '過去実績を登録します。よろしいですか。',
  CONFIRM_OUTPUT_EXCEL: 'Excel出力を行います。よろしいですか。',
  CONFIRM_UNSAVED: '保存していませんがよろしいですか。',
  CONFIRM_RESET_CARRY_CALCULATION: '搬入割合をリセットします。よろしいですか。',
  CONFIRM_RESET_TO_ORIGIN: '初期設定に戻します。よろしいですか。',
  CONFIRM_SET_INITIAL_PLAN_SETTING: '期初計画に設定します。よろしいですか。',
  CONFIRM_CANCEL_INITIAL_PLAN_SETTING: '期初計画を撤回します。よろしいですか。',

  SUCCESS_POST_FORM: '入力内容を登録しました。',
  SUCCESS_AUTO_DRAFT_REQUEST: '自動立案を開始しました。処理完了時にメールでお知らせします。',
  SUCCESS_SAVE_FORM: '入力内容を一時保存しました。',
  SUCCESS_POST_HISTORY: '過去実績を登録しました。',
  SUCCESS_SAVE: '入力内容を保存しました。',
  SUCCESS_FIX_DRAFT: '案を確定しました。',
  SUCCESS_RESET: '編集前に戻しました。',
  SUCCESS_SET_INITIAL_PLAN_SETTING: '期初計画に設定しました。',
  SUCCESS_CANCEL_INITIAL_PLAN_SETTING: '期初計画を撤回しました。',

  ERROR_MESSAGE_DIALOG_UNHANDLED: '処理中にエラーが発生しました。', // メッセージダイアログの非同期処理中の例外スロー時
  ERROR_SERVER: 'サーバー処理中にエラーが発生しました。',
  ERROR_AUTH: 'ユーザIDとパスワードが一致しません。',

  ERROR_NOTFOUND_FILE: 'ファイルが選択されていません。',
  ERROR_IMPORT_FILE: 'ファイルの取り込みに失敗しました。',

  ERROR_SESSION_TIMEOUT: 'セッションがタイムアウトしました。ログインページに戻ります。',

  ERROR_VALIDATION_REQUIRED: (fieldName: string) => `${fieldName}が入力されていません。`,

  ERROR_VALIDATION_INVALID_VALUE: (fieldName: string) => `${fieldName}に有効な値が入力されていません。`,

  SUCCESS_BURN_VOLUME: (shutdownDate: string, launchDate: string, burnVolume: String) => `${shutdownDate} ~ ${launchDate} の期間に焼却量${burnVolume}tを適用しました。`,
};

export const COLOR_CODE = {
  INITIAL: '#A3EDED',
  PLAN: '#D48EAF',
  RESULT: '#D4CC8E',
  DRAFT1: '#8ED48F',
  DRAFT2: '#8EA5D4',
  DRAFT3: '#D4BE8E',
  DRAFT4: '#C28ED4',
  DRAFT5: '#948982',
};

export const LINE_SEQ = {
  INITIAL: 0,
  PLAN: 1,
  RESULT: 2,
  DRAFT1: 3,
  DRAFT2: 4,
  DRAFT3: 5,
  DRAFT4: 6,
  DRAFT5: 7,
};

//ENVIRONMENT:LOCAL,DEVELOP,STAGING,PRODUCTION
export const ENVIRONMENT = 'PRODUCTION';

export const LAMBDA_URL = (() => {
  const urls = {
    LOCAL: '',
    DEVELOP: 'https://develop.auto-operation-planner.link/api/',
    STAGING: 'https://staging.auto-operation-planner.link/api/',
    PRODUCTION: 'https://auto-operation-planner.link/api/',
  };

  return urls[ENVIRONMENT];
})();
